<div class="chat-widget">
  <!-- Header -->
  <div class="chat-header">
    <div class="header-content">
      <div class="header-icon">🤖</div>
      <div class="header-text">
        <h3>AI Assistant</h3>
        <span class="header-status">Online</span>
      </div>
    </div>
    <div class="header-actions">
      <button class="header-btn" (click)="clearChat()" title="Clear chat">
        🗑️
      </button>
      <button class="header-btn close-btn" (click)="closeWidget()" title="Close">
        ✕
      </button>
    </div>
  </div>

  <!-- User Info Bar -->
  <div class="user-info">
    <small>{{ getAuthStatus() }}</small>
  </div>

  <!-- Messages Area -->
  <div class="messages-container">
    <div class="messages">
      <div
        *ngFor="let message of messages"
        class="message"
        [class.user-message]="message.role === 'user'"
        [class.assistant-message]="message.role === 'assistant'">
        <div class="message-avatar">
          {{ message.role === 'user' ? '👤' : '🤖' }}
        </div>
        <div class="message-bubble">
          <div class="message-content" 
               [innerHTML]="renderMarkdown(message.content, message.role)">
          </div>
          <div class="message-time">{{ message.timestamp | date:'short' }}</div>
        </div>
      </div>

      <!-- Typing indicator until the first streamed token arrives -->
      <div *ngIf="isLoading && (messages.length === 0 || messages[messages.length - 1].role !== 'assistant')"
           class="message assistant-message loading">
        <div class="message-avatar">🤖</div>
        <div class="message-bubble">
          <div class="message-content">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Input Area -->
  <div class="input-container">
    <textarea
      [(ngModel)]="userInput"
      (keypress)="onKeyPress($event)"
      placeholder="Type your message..."
      [disabled]="isLoading"
      rows="1"></textarea>
    <button
      (click)="sendMessage()"
      [disabled]="!userInput.trim() || isLoading"
      class="send-btn">
      <span *ngIf="!isLoading">📤</span>
      <span *ngIf="isLoading" class="loading-spinner">⏳</span>
    </button>
  </div>
</div>
